const mutations = {
  // 更新联系我们弹窗状态
  UPDATE_SHOW_CONTACT_DIALOG(state, payload) {
    state.showContactDialog = payload
  },
}

export default mutations
